export default {
  mainCampaign: {
    values: []
  },
  activeBlock: {
    indexChannel: null
  },
  inactiveFlow: false,
  auxiliares: {},
  collapse:{
    channels : false,
    audience: false,
    time: false,
    content: false
  },
  autoSaving: null
}
